export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img11-db9a68d68fca6d2a247ed165235e87a3.png";